import { render, staticRenderFns } from "./DocumentsInfo.vue?vue&type=template&id=3c47649a"
import script from "./DocumentsInfo.vue?vue&type=script&lang=js"
export * from "./DocumentsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports